<template>
  <div>
    <Main
      :disabled="disabled"
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @openEditFormDialog="openEditFormDialog"
      @reload="getData"
    />

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="750px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => closeEditFormDialog"
    >
      <edit-form
        ref="editForm"
        :purchasePackageExpenseCode="editFormDialogOptions.code"
        :packageDetailCode="packageDetailCode"
        :packageCode="packageCode"
        :disabled="editFormDialogOptions.disabled"
        @close="closeEditFormDialog"
        @reload="getData"
      />
      <span slot="footer">
        <el-button
          size="small"
          @click="editFormDialogOptions.visible = false"
          >{{ $l("INDEX.btn_cancel") || "取消" }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="save"
          >{{ $l("INDEX.btn_save") || "保存" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditForm from "./edit-form"
import BaseTable from "@/mixins/base-table"
import Main from "./main.vue"
export default {
  mixins: [BaseTable],
  components: { Main, EditForm },
  props: {
    disabled: Boolean,
    packageDetailCode: String,
    packageCode: String,
  },
  data() {
    return {
      loading: false,
      usePage: true,
      editFormDialogOptions: {
        disabled: false,
        visible: false,
        code: "",
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    save() {
      this.$refs.editForm.save()
    },
    getData() {
      if (!this.packageDetailCode && !this.packageCode) return
      this.loading = true
      this.$api
        .purchasePackageExpenseListApi({
          purchasePackageDetailCode: this.packageDetailCode,
          purchasePackageCode: this.packageCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit:
          this.$l("form_label_packag_expense_edit") ||
          "编辑包装采购单附加费明细",
        add:
          this.$l("form_label_packag_expense_add") ||
          "新增包装采购单附加费明细",
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.code,
        disabled: type === "detail",
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
